var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.0748,
    cy: 38.4,
    r: 38.4,
    fill: "#FFC530"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.95 41.2252V34.7752H37.8V41.2252H40.95ZM40.95 47.6002V44.3752H37.8V47.6002H40.95ZM21.75 52.4002L39.375 22.0252L57 52.4002H21.75Z",
    fill: "#F1F2F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.d0ba1dd58b65f1b163c54aa83ffbfb1a.svg";
export { ForwardRef as ReactComponent };